export const getFilterOverlayVisible = state =>
  state.layout.isFilterOverlayVisible;
export const getViewportCategory = state => state.layout.viewportCategory;
